module.exports = __webpack_public_path__ + "img/map-nav-orange.0ac156a7.svg";